import React, { Component } from 'react'
// import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { withTheme, withStyles } from 'material-ui/styles'
import _ from 'lodash'
// import qs from 'query-string'

import Icon from 'material-ui/Icon'

import Typography from 'material-ui/Typography'
import Toolbar from 'material-ui/Toolbar'

const styles = theme => ({
  typographyRoot: {
    fontSize: '0.85rem',
    color: theme.palette.primary.main,
    paddingBottom: '11px'
  }
})

class DrawerToolbar extends Component {
  state = {
    // activeIndex: null,
    data: []
  }
  componentWillMount() {
    const {
      innerRouterInput: { listScreenData }
    } = this.props
    this.setState({ data: listScreenData })
  }

  handleSwitch = (data, formIndex, index, recordId, dir) => {
    const {
      history: { push },
      path,
      forms
    } = this.props

    const formName = this.matchForm(forms, formIndex)

    const switchId =
      _.get(data, `[${index + (dir === 'up' ? 1 : -1)}].id`) || -1
    if (switchId > -1) {
      push(`${path}${switchId}/${formName}`)
    }
  }

  matchForm = (forms, value, id = true) => {
    return id
      ? _.get(
          forms,
          `[${_.findIndex(forms, ['id', value])}].name`,
          forms[0].name || ''
        )
      : _.get(
          forms,
          `[${_.findIndex(forms, ['name', value])}].id`,
          forms[0].id || 1
        )
  }

  render() {
    const {
      match: {
        params: { id, form }
      },
      forms,
      // path,
      classes,
      title
    } = this.props
    const { data } = this.state

    const currentActive = this.matchForm(forms, form)
    const activeIndex = _.findIndex(data, ['id', id * 1])

    // const formName = this.matchForm(forms, currentActive)

    return (
      <div
        style={{
          width: 300,
          marginTop: 'calc(162px - 147px)'
        }}
      >
        <Toolbar
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingLeft: '5px',
            paddingRight: '5px'
          }}
        >
          {activeIndex > 0 ? (
            <Icon
              style={{ cursor: 'pointer' }}
              onClick={() =>
                this.handleSwitch(data, currentActive, activeIndex, id, 'down')
              }
            >
              chevron_left
            </Icon>
          ) : (
            <Icon style={{ color: '#ccc' }}>chevron_left</Icon>
          )}

          <Typography classes={{ root: classes.typographyRoot }} type="title">
            {title.toUpperCase()}
          </Typography>
          {activeIndex < data.length - 1 ? (
            <Icon
              style={{ cursor: 'pointer' }}
              onClick={() =>
                this.handleSwitch(data, currentActive, activeIndex, id, 'up')
              }
            >
              chevron_right
            </Icon>
          ) : (
            <Icon style={{ color: '#ccc' }}>chevron_right</Icon>
          )}
        </Toolbar>
      </div>
    )
  }
}

DrawerToolbar.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(withTheme()(DrawerToolbar))



// WEBPACK FOOTER //
// ./src/common/components/DrawerToolbar.js